/* eslint-disable max-len */
import * as React from 'react';
import { Timeline, Icon, Button, Modal, Toast } from '@roo/roo';
import './index.scss';
import { getCookie } from '@utiljs/cookie';
import request from '@/utils/request';
import timeFormatUtil from './api/time';
import HistoryList from './components/ historyList';
import { getProviderContact, updateProviderContact } from './api';
import utils from '@/utils/utils';

let timer: any = null;

const { useState, useEffect } = React;
const RefundDetails = () => {
    const [orderViewId, setOrderViewId] = useState('');
    const [providerId, setProviderId] = useState('');
    const [showTimeLine, setShowTimeLine] = useState(true);
    const [showButton, setShowButton] = useState(true);
    const [showTracks, setShowTracks] = useState(false);
    const [titleText, setTitleText] = useState('买家发起退款，请您及时处理');
    const [afterSaleText, setAfterSaleText] = useState('');
    const [tipText, setTipText] = useState('');
    const [image, setImage] = useState('');
    const [refuseReason, setRefuseReason] = useState('');
    const [sellerAddress, setSellerAddress] = useState('');
    const [sellerName, setSellerName] = useState('');
    const [sellerPhone, setSallerPhone] = useState('');
    const [refundTime, setRefundTime] = useState('');
    const [applyTime, setApplyTime] = useState('');
    const [refundMoney, setRefundMoney] = useState('');
    const [refundReason, setRefundReason] = useState('');
    const [agreeModalVisable, setAgreeModalVisable] = useState(false);
    const [rejectModalVisable, setRejectModalVisable] = useState(false);
    const [afterSaleId, setAfterSaleId] = useState('');
    const [itemName, setItemName] = useState('');
    const [versionName, setVersionName] = useState('');
    const [versionUnitPrice, setVersionUnitPrice] = useState('');
    const [count, setCount] = useState(1);
    const [remainingTime, setRemainingTime] = useState('');
    const [afterSaleType, setAfterSaleType] = useState(1);
    const [afterSaleStatus, setAfterSaleStatus] = useState(1);
    const [expressCode, setExpressCode] = useState('');
    const [expressName, setExpressName] = useState('');
    const [expressNumber, setExpressNumber] = useState('');
    const [expressTracks, setExpressTracks] = useState([]);
    const [onFocus, setOnFocus] = useState(false);
    const undoneIcon = <Icon name="circle-o" style={{ marginLeft: '-2px' }} />;
    const doneIcon = (
        <Icon name="check-circle" style={{ marginLeft: '-2px', color: 'rgb(255,201,77)' }} />
    );
    const getDetail = async (orderViewId: string) => {
        const params = {
            orderViewId,
        };
        const res = await request.get('/api/after/sale/detail', params, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const {
            afterSaleId,
            refundTime,
            refundMoney,
            refundReason,
            remainingTime,
            afterSaleType,
            afterSaleItemVersions,
            afterSaleStatus,
            applyTime,
            refuseReason,
            operator,
            operateTime,
            sellerAddress,
            sellerName,
            sellerPhone,
        } = res.data;
        if (afterSaleType === 2 && afterSaleStatus >= 20) {
            setShowTracks(true);
            getLogistics(afterSaleId);
        }
        const { image, itemName, versionName, versionUnitPrice, count } = afterSaleItemVersions[0];
        setAfterSaleId(afterSaleId);
        setRefundTime(timeFormatUtil.timeFormatForRefundTime(Number(refundTime)));
        setApplyTime(timeFormatUtil.timeFormat(Number(applyTime)));
        setRefundMoney(refundMoney);
        setRefundReason(refundReason);
        setImage(image);
        setItemName(itemName);
        setVersionName(versionName);
        setVersionUnitPrice(versionUnitPrice);
        setCount(count);
        setRemainingTime(timeFormatUtil.remainingTimeFormat(Number(remainingTime)));
        countDown(remainingTime, orderViewId);
        setAfterSaleType(afterSaleType);
        setAfterSaleStatus(afterSaleStatus);
        setRefuseReason(refuseReason);
        if (afterSaleStatus === 1 && afterSaleType === 2) {
            getProviderContactData();
        } else {
            setSallerPhone(sellerPhone);
            setSellerAddress(sellerAddress);
            setSellerName(sellerName);
        }

        if (afterSaleStatus === 1 && afterSaleType !== 2) {
            setTipText('请您尽快处理退款，超时自动同意');
        }
        if (afterSaleStatus === 10) {
            setTitleText('您已同意退货');
            setTipText(
                `您已同意退货,买家将在${timeFormatUtil.getDay(
                    Number(remainingTime),
                )}天内按照右侧地址退还商品`,
            );
            setShowButton(false);
        }
        if (afterSaleStatus === 11) {
            setTitleText('您已拒绝退货，退款失败');
            if (refuseReason) {
                setAfterSaleText(`拒绝原因:${refuseReason}`);
            }
            setShowTimeLine(false);
            setShowButton(false);
        }
        if (afterSaleStatus === 20) {
            setTitleText('买家已退货，请确认退款');
            setShowButton(true);
        }
        if (afterSaleStatus === 21) {
            setTitleText('您已同意退款');
            setTipText('您已经同意退款，银行处理中');
            setShowButton(false);
        }
        if (afterSaleStatus === 22) {
            setTitleText(`您已拒绝${afterSaleType === 4 ? '退款并解约' : '退款'}，退款失败`);
            setAfterSaleText(`拒绝原因:${refuseReason}`);
            setShowTimeLine(false);
            setShowButton(false);
        }
        if (afterSaleStatus === 30) {
            setTitleText('退款已取消');
            if (operator === 1) {
                setAfterSaleText(`系统已取消售后
                ${timeFormatUtil.timeFormatForRefundTime(Number(operateTime))}`);
            }
            if (operator === 2) {
                setAfterSaleText(`买家已取消售后
                ${timeFormatUtil.timeFormatForRefundTime(Number(operateTime))}`);
            }
            setShowButton(false);
            setShowTimeLine(false);
        }
        if (afterSaleStatus === 40) {
            setTitleText(
                `系统异常，${afterSaleType === 4 ? '退款并解约' : '退款'}失败，请联系客服人员`,
            );
            setShowTimeLine(false);
            setShowButton(false);
        }
        if (afterSaleStatus === 50) {
            setTitleText(`${afterSaleType === 4 ? '退款并解约' : '退款'}成功`);
            setTipText(`退款总金额:￥${refundMoney}`);
            setShowButton(false);
        }
    };
    const countDown = (remainingTime, orderViewId) => {
        // eslint-disable-next-line no-param-reassign
        if (!remainingTime) {
            return;
        }
        let timer: any = null;
        // eslint-disable-next-line no-param-reassign
        remainingTime = Number(remainingTime);
        timer = setInterval(() => {
            // eslint-disable-next-line no-param-reassign
            remainingTime -= 1;
            if (remainingTime === 0) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                getDetail(orderViewId);
                clearInterval(timer);
            }
            setRemainingTime(timeFormatUtil.remainingTimeFormat(remainingTime));
        }, 1000);
    };
    const getLogistics = async (afterSaleId: string) => {
        const params = {
            afterSaleId,
            providerId,
        };
        const res = await request.get('/api/after/sale/return/logistics/detail', params, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const { logisticsInfos } = res.data;
        const { expressCode, expressName, expressNumber, expressTracks } = logisticsInfos[0];
        if (!expressCode || !expressName || !expressNumber) {
            setShowTracks(false);
        }
        setExpressCode(expressCode);
        setExpressName(expressName);
        setExpressNumber(expressNumber);
        setExpressTracks(expressTracks);
    };
    const agreeRefund = () => {
        const params = {
            afterSaleId,
            afterSaleType,
            refundMoney,
            providerId,
            orderViewId,
        };
        request
            .post(
                '/api/after/sale/refund/agree',
                params,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
                false,
            )
            .then(() => {
                setShowButton(false);
            })
            .catch(error => {
                utils.toast('error', error.response.data.msg || '数据请求错误~', 5000);
            });
    };
    const refuseRefund = () => {
        const params = {
            afterSaleId,
            afterSaleType,
            refundMoney,
            providerId,
            orderViewId,
            refuseReason,
        };
        request.post('/api/after/sale/refund/refuse', params, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };
    const agreeReturn = () => {
        const params = {
            afterSaleId,
            afterSaleType,
            refundMoney,
            providerId,
            orderViewId,
            sellerName,
            sellerPhone,
            sellerAddress,
        };
        request
            .post(
                '/api/after/sale/product/return/agree',
                params,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
                false,
            )
            .then(() => {
                setShowButton(false);
            })
            .catch(error => {
                utils.toast('error', error.response.data.msg || '数据请求错误~', 5000);
            });
    };
    const refuseReturn = () => {
        const params = {
            afterSaleId,
            afterSaleType,
            refundMoney,
            providerId,
            orderViewId,
            refuseReason,
        };
        request.post('/api/after/sale/product/return/refuse', params, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };
    const onComfirmRefund = () => {
        agreeRefund();
        setAgreeModalVisable(false);
        // setShowButton(false);
        setTimeout(() => {
            getDetail(orderViewId);
        }, 500);
    };
    const onRefuseRefund = () => {
        if (!refuseReason) {
            Toast.open({
                title: '必须填写拒绝原因',
                status: 'warning',
            });
            setRejectModalVisable(false);
            return;
        }
        refuseRefund();
        setRejectModalVisable(false);
        setShowButton(false);
        setTimeout(() => {
            getDetail(orderViewId);
        }, 500);
    };
    const onComfirmReturn = () => {
        if (!sellerAddress || !sellerName || !sellerPhone) {
            Toast.open({
                title: '必须填写完整的退货地址信息',
                status: 'warning',
            });
            setAgreeModalVisable(false);
            return;
        }
        agreeReturn();
        setAgreeModalVisable(false);
        // setShowButton(false);
        setTimeout(() => {
            getDetail(orderViewId);
        }, 500);
    };
    const onRefuseReturn = () => {
        if (!refuseReason) {
            Toast.open({
                title: '必须填写拒绝原因',
                status: 'warning',
            });
            setRejectModalVisable(false);
            return;
        }
        refuseReturn();
        setRejectModalVisable(false);
        setShowButton(false);
        setTimeout(() => {
            getDetail(orderViewId);
        }, 500);
    };
    const getQuery = () => {
        const { href } = window.location;
        const queryString = href.split('?')[1];
        const orderViewId = queryString.split('=')[1];
        setOrderViewId(orderViewId);
        getDetail(orderViewId);
    };
    // e: React.FocusEvent<HTMLInputElement>
    const handleBlur = () => {
        if (/^1\d{10}$/.test(sellerPhone)) {
            timer = setTimeout(() => {
                setOnFocus(false);
                timer = null;
            });
            return;
        }
        Toast.open({
            title: '请填写11位手机号',
            position: 'topCenter',
            closable: true,
            duration: 3000,
            status: 'fail',
        });
    };
    const handleFocus = () => {
        clearTimeout(timer);
        setOnFocus(true);
    };

    const getProviderContactData = () => {
        const providerId = getCookie('serviceProviderID');
        getProviderContact(providerId).then(res => {
            const { sellerAddress, sellerName, sellerPhone } = res.data;
            setSallerPhone(sellerPhone);
            setSellerAddress(sellerAddress);
            setSellerName(sellerName);
        });
    };

    useEffect(() => {
        setProviderId(getCookie('serviceProviderID'));
        getQuery();
    }, []);

    // 退款详情div
    const getRefundDetail = () => (
        <div className="allAreaBox">
            <h4 className="topLine">退款详情/退款审核</h4>
            <div>
                <h3 className="bigLine">{titleText}</h3>
                {afterSaleStatus === 50 ? <div className="refundTime">{refundTime}</div> : null}
            </div>
            {showTimeLine ? (
                <div className="timeLine">
                    {/* @ts-ignore */}
                    <Timeline>
                        <Timeline.Item dot={afterSaleStatus < 1 ? undoneIcon : doneIcon}>
                            <div className={afterSaleStatus < 1 ? 'blackFont' : 'yellowFont'}>
                                卖家审核
                            </div>
                        </Timeline.Item>
                        {afterSaleType === 2 ? (
                            // eslint-disable-next-line max-len
                            <Timeline.Item dot={afterSaleStatus < 10 ? undoneIcon : doneIcon}>
                                <div className={afterSaleStatus < 10 ? 'blackFont' : 'yellowFont'}>
                                    退回商品
                                </div>
                            </Timeline.Item>
                        ) : null}
                        <Timeline.Item dot={afterSaleStatus < 20 ? undoneIcon : doneIcon}>
                            <div className={afterSaleStatus < 20 ? 'blackFont' : 'yellowFont'}>
                                卖家退款
                            </div>
                        </Timeline.Item>
                        <Timeline.Item dot={afterSaleStatus !== 50 ? undoneIcon : doneIcon}>
                            <div className={afterSaleStatus !== 50 ? 'blackFont' : 'yellowFont'}>
                                退款成功
                            </div>
                        </Timeline.Item>
                    </Timeline>
                    <div className="tipText">{tipText}</div>
                </div>
            ) : (
                <div className="afterSaleStatus">{afterSaleText}</div>
            )}
            <h3 className="bigLine">退款信息</h3>
            <div className="refundInfoWrapper">
                <div className="infoHeader">
                    <img src={image} alt="图片损坏" className="merchant" />
                    <div className="serviceName">
                        <div>{itemName}</div>
                        <div className="versionName">{versionName}</div>
                    </div>
                    <div className="amountAndCount">
                        <div className="amount">￥{versionUnitPrice}</div>
                        <div className="count">&nbsp;x&nbsp;{count}</div>
                    </div>
                </div>
                <div className="infoBody">
                    <div className="infoItem">
                        <div className="infoName">退款原因</div>
                        <div className="infoValue">{refundReason}</div>
                    </div>
                    <div className="infoItem">
                        <div className="infoName">退款金额</div>
                        <div className="infoValue">￥{refundMoney}</div>
                    </div>
                    <div className="infoItem">
                        <div className="infoName">申请件数</div>
                        <div className="infoValue">{count}</div>
                    </div>
                    <div className="infoItem">
                        <div className="infoName">申请时间</div>
                        <div className="infoValue">{applyTime}</div>
                    </div>
                    <div className="infoItem">
                        <div className="infoName">退款编号</div>
                        <div className="infoValue">{afterSaleId}</div>
                    </div>
                    <div className="infoItem">
                        <div className="infoName">订单编号</div>
                        <div className="infoValue">{orderViewId}</div>
                    </div>
                </div>
                {showButton ? (
                    <div className="footer">
                        <Button
                            type="brand-hollow"
                            className="agree"
                            onClick={() => {
                                setAgreeModalVisable(true);
                            }}
                        >
                            {afterSaleStatus === 1 && afterSaleType === 2 ? (
                                <div className="agreeButtonWithoutTime">同意</div>
                            ) : (
                                <div className="agreeButtonWithTime">
                                    同意<span>&nbsp;</span>
                                    <span>{remainingTime}</span>
                                </div>
                            )}
                        </Button>
                        {afterSaleStatus === 1 && afterSaleType === 2 && (
                            <div className="divWithWidth" />
                        )}
                        <Button
                            type="hollow"
                            className="reject"
                            onClick={() => {
                                setRejectModalVisable(true);
                            }}
                        >
                            驳回
                        </Button>
                    </div>
                ) : null}
            </div>
        </div>
    );

    // 退款地址div
    const getRefundAddress = () => (
        <div className="allAreaBox">
            {
                // eslint-disable-next-line max-len
                (afterSaleStatus === 1 ||
                    afterSaleStatus === 10 ||
                    afterSaleStatus === 20 ||
                    showTracks) && (
                    <div className="refundDetail">
                        <h4 className="topLine">
                            退货地址
                            {afterSaleStatus === 1 && (
                                <Icon
                                    name="edit"
                                    size={20}
                                    className="editIcon"
                                    onClick={() => {
                                        setOnFocus(!onFocus);
                                    }}
                                />
                            )}
                        </h4>
                        <div className="receiver">
                            收货人:
                            {onFocus && (
                                <input
                                    type="text"
                                    value={sellerName}
                                    onChange={e => {
                                        setSellerName(e.target.value);
                                    }}
                                    onBlur={handleBlur}
                                    onFocus={handleFocus}
                                    className="receiverInput"
                                />
                            )}
                            {!onFocus && sellerName}
                        </div>
                        <div className="receiver">
                            电话:
                            {onFocus && (
                                <input
                                    type="text"
                                    value={sellerPhone}
                                    onChange={e => {
                                        setSallerPhone(e.target.value);
                                    }}
                                    onBlur={handleBlur}
                                    onFocus={handleFocus}
                                    className="telephoneNumberInput"
                                />
                            )}
                            {!onFocus && sellerPhone}
                        </div>
                        <div className="receiver">
                            地址:
                            {onFocus && (
                                <input
                                    type="text"
                                    value={sellerAddress}
                                    onChange={e => {
                                        setSellerAddress(e.target.value);
                                    }}
                                    onBlur={handleBlur}
                                    onFocus={handleFocus}
                                    className="addressInput"
                                />
                            )}
                            {!onFocus && sellerAddress}
                        </div>
                    </div>
                )
            }
            {showTracks && (
                <div className="logisticsInformation">
                    <p className="logisticsTitle">退货物流</p>
                    <div className="expressCode">物流公司编号:{expressCode}</div>
                    <div className="expressName">
                        {expressName}&nbsp;{expressNumber}
                    </div>
                    <div className="expressTracks">物流详情:</div>
                    <div>
                        <Timeline Item={Timeline.Item} className="expressTimeline">
                            {expressTracks.map((item: any) => (
                                <Timeline.Item>
                                    <div>
                                        <div>
                                            {/* @ts-ignore */}
                                            {item?.statusName}&nbsp;
                                            {timeFormatUtil.timeFormat(Number(item?.arrivalTime))}
                                        </div>
                                        {/* @ts-ignore */}
                                        <div>{item?.statusDesc}</div>
                                    </div>
                                </Timeline.Item>
                            ))}
                        </Timeline>
                    </div>
                </div>
            )}
        </div>
    );

    // 售后历史div
    const getRefundHistory = () => (
        <div className="allAreaBox">
            <h4 className="topLine">售后历史</h4>
            <HistoryList orderViewId={orderViewId} />
        </div>
    );

    return (
        <div className="refundDetailsPage">
            <div className="allArea">
                {getRefundDetail()}
                {afterSaleType === 2 ? getRefundAddress() : null}
                {getRefundHistory()}
                {/* 同意 */}
                <Modal
                    title={afterSaleType === 2 && afterSaleStatus === 1 ? '同意退货' : '同意退款'}
                    visible={agreeModalVisable}
                    onCancel={() => {
                        setAgreeModalVisable(false);
                    }}
                    onConfirm={() => {
                        if (afterSaleType === 2 && afterSaleStatus === 1) {
                            const param = { providerId, sellerName, sellerAddress, sellerPhone };
                            onComfirmReturn();
                            updateProviderContact(param);
                            return;
                        }
                        onComfirmRefund();
                    }}
                >
                    {afterSaleType === 2 && afterSaleStatus === 1
                        ? '请您核对退货地址和收货人信息，点击确认后买家将按填写的地址退货。'
                        : '操作退款后，将全额退款给买家，确认要退款吗？'}
                </Modal>
                {/* 驳回 */}
                <Modal
                    title={
                        afterSaleType === 2 && afterSaleStatus === 1
                            ? '请填写拒绝退货原因'
                            : '请填写拒绝退款原因'
                    }
                    visible={rejectModalVisable}
                    onCancel={() => {
                        setRejectModalVisable(false);
                    }}
                    onConfirm={() => {
                        if (afterSaleType === 2 && afterSaleStatus === 1) {
                            onRefuseReturn();
                            return;
                        }
                        onRefuseRefund();
                    }}
                >
                    <div>
                        <textarea
                            className="textarea"
                            maxLength={100}
                            onChange={e => {
                                setRefuseReason(e.target.value);
                            }}
                        />
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default RefundDetails;
